/* eslint-disable */
export default {
  DirectNumber: '직접',
  MainCompanyNumber: '주요',
  CompanyNumber: '회사',
  CompanyFaxNumber: '팩스',
  Blocked: '차단됨',
  AdditionalCompanyNumber: '회사',
  ForwardedCompanyNumber: '착신 전환됨',
  from: '발신자',
} as const;

// @key: @#@"DirectNumber"@#@ @source: @#@"Direct"@#@
// @key: @#@"MainCompanyNumber"@#@ @source: @#@"Main"@#@
// @key: @#@"CompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"CompanyFaxNumber"@#@ @source: @#@"Fax"@#@
// @key: @#@"Blocked"@#@ @source: @#@"Blocked"@#@
// @key: @#@"AdditionalCompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"ForwardedCompanyNumber"@#@ @source: @#@"Forwarded"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
